module.exports = __webpack_public_path__ + "static/media/Rufflet_gaussian2.bc39e3c4.png";